import { ReactElement, ReactNode } from 'react';

import { Box } from '@breathelife/mui';
import { BaseESignSigner } from '@breathelife/types';

import { GreyContainer } from '../../../../../Components/AssistedApplication/Styles';
import Typography from '../../../../../Components/Typography';

import { ParticipantRoleBadge } from '../../../../Badge/ParticipantRoleBadge';
import { ParticipantRole } from '@zinnia/form-engine-sdk';

type SignerInfoHeaderProps = {
  signer: BaseESignSigner;
  rightSlot?: ReactNode;
};

export function SignerInfoHeader(props: SignerInfoHeaderProps): ReactElement {
  const { signer, rightSlot } = props;
  const { firstName, lastName, roles } = signer;

  return (
    <GreyContainer display='flex' justifyContent='space-between' alignItems='center' py={1} px={2} mb={2}>
      <Box display='flex' alignItems='center'>
        <Box display='flex' alignItems='center'>
          <Typography variant='h4' component='span'>
            {firstName} {lastName} :
          </Typography>
        </Box>
        <Box display='flex' alignItems='center'>
          {roles.map((role) => (
            <Box ml={1} key={role.type}>
              <ParticipantRoleBadge role={role.type as ParticipantRole} />
            </Box>
          ))}
        </Box>
      </Box>
      {rightSlot && <Box>{rightSlot}</Box>}
    </GreyContainer>
  );
}
